import Vue from "vue";
import Router from "vue-router";

import Login from "./views/sessions/Login.vue";
import PasswordRecovery from "./views/sessions/PasswordRecovery.vue";
import PasswordChange from "./views/sessions/PasswordChange.vue";

import UserIndex from "./views/users/UserIndex.vue";
import UserNew from "./views/users/UserNew.vue";
import UserEdit from "./views/users/UserEdit.vue";

import DocumentIndex from "./views/documents/DocumentIndex.vue";

import LogIndex from "./views/logs/LogIndex.vue";

import session from "./services/SessionService";
import searchService from "@/services/SearchService";

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/documents",
      name: "documents",
      component: DocumentIndex,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/logs",
      name: "logs",
      component: LogIndex,
      meta: {
        requiresSuperAdmin: true
      }
    },
    {
      path: "/users",
      name: "users",
      component: UserIndex,
      meta: {
        requiresAdmin: true
      }
    },
    {
      path: "/users/new",
      name: "users_new",
      component: UserNew,
      meta: {
        requiresAdmin: true
      }
    },
    {
      path: "/users/:id",
      name: "users_edit",
      component: UserEdit,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        guest: true
      }
    },
    {
      path: "/recovery",
      name: "recovery",
      component: PasswordRecovery,
      meta: {
        guest: true
      }
    },
    {
      path: "/password_change",
      name: "password_change",
      component: PasswordChange,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "*",
      redirect: "/documents"
    }
  ]
});

router.beforeEach((to, from, next) => {
  // Clears pagination and search filters before each route change
  searchService.clear();

  if (!session.getUser() && !!session.securels.get("user")) {
    session.setUser(session.securels.get("user"));
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!session.getToken()) {
      next({
        path: "/login",
        params: { nextUrl: to.fullPath }
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (!session.getToken()) {
      next();
    } else {
      next({ path: "/" });
    }
  } else if (to.matched.some(record => record.meta.requiresAdmin)) {
    let user = session.getUser();
    if (user && (user.is_admin || user.is_superadmin)) {
      next();
    } else {
      next({ path: "/" });
    }
  } else if (to.matched.some(record => record.meta.requiresSuperAdmin)) {
    let user = session.getUser();
    if (user && user.is_superadmin) {
      next();
    } else {
      next({ path: "/" });
    }
  } else {
    next();
  }
});

export default router;
